export const SET_THEME_PROPERTIES = 'SET_THEME_PROPERTIES';
export const SET_SHOULD_BE_SAVED = 'SET_SHOULD_BE_SAVED';
export const SET_CURRENT_THEME_ID = 'SET_CURRENT_THEME_ID';
export const SET_CURRENT_THEME_TITLE = 'SET_CURRENT_THEME_TITLE';
export const SET_CURRENT_THEME_PROPERTIES = 'SET_CURRENT_THEME_PROPERTIES';
export const ADD_NEW_THEME = 'ADD_NEW_THEME';
export const ADD_NEW_THEME_SUCCESS = 'ADD_NEW_THEME_SUCCESS';
export const ADD_NEW_THEMES = 'ADD_NEW_THEMES';
export const UPDATE_THEME = 'UPDATE_THEME';
export const UPDATE_THEME_SUCCESS = 'UPDATE_THEME_SUCCESS';
export const DELETE_THEME = 'DELETE_THEME';
export const DELETE_THEME_SUCCESS = 'DELETE_THEME_SUCCESS';
export const SET_CURRENT_TAB = 'SET_CURRENT_TAB';
export const SET_IS_SAVING = 'SET_IS_SAVING';
export const SETUP_THEMES = 'SETUP_THEMES';
export const ADD_GALLERY_THEMES = 'ADD_GALLERY_THEMES';
